import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { RouterModule, Routes } from '@angular/router';


import { AppComponent } from './app.component';
import { AuthGuardService } from './services/authGuard';
import { LayoutModule } from './layout/layout.module';
//Custom Pipes/Filters


//External Plugins
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ManageContentComponent } from './manage-content/manage-content.component';
import { PhoneBookComponent } from './phone-book/phone-book.component';
import { phoneBookFilter } from './phone-book/phone-book.pipe';
import { listiniVenditaModule } from './listini-vendita/listiniVendita.module';
import { HomeModule } from './home/home.module';
import { LoginModule } from './login/login.module';
import { InternationalActivitiesModule } from './international-activities/InternationalActivities.module';
import { LazyForDirective } from './directives/lazy-for.directive';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import localeEn from '@angular/common/locales/en';
import { DateLocaleFilter } from './custom-pipes/date-local.pipe';
import { UserComponent } from './user/user.component';
import { MeetingRoomStatusComponent } from './meeting-room-status/meeting-room-status.component';
import { ChangelogComponent } from './layout/changelog/changelog.component';
import { ServiceItaModule } from './service-ita/service-ita.module';
import { InternationalActivitiesUsermanualsModule } from './international-activities-usermanuals/InternationalActivities-usermanuals.module';
import { InternationalActivitiesdetailModule } from './international-activities-detail/InternationalActivities-detail.module';
import { EqualtecModule } from './equaltec/equaltec.module';
//import { EqualtecdetailModule } from './equaltec-detail/equaltec-detail.module';




import { CommonModule } from '@angular/common';


//plugins
import {TranslateService } from '@ngx-translate/core';

import {  NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';


import { HomeComponent } from './home/home.component';


import { LoginComponent } from './login/login.component';
import { OpenIdLoginComponent } from './openIdLogin/openIdLogin.component';
import { OpenIdLoginModule } from './openIdLogin/openIdLogin.module';
import {EqualtecModalPresavisioneComponent} from './equaltec/equaltec-modal-presavisione/equaltec-modal-presavisione.component';




const routes: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  }
];

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '-lang.json');
}



@NgModule({
  declarations: [
    AppComponent,
    ManageContentComponent,
    PhoneBookComponent,
    phoneBookFilter,
    LazyForDirective,
    DateLocaleFilter,
    UserComponent,
    MeetingRoomStatusComponent,
  ],
  imports: [
    LayoutModule,
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    LoadingBarHttpClientModule,
    Ng2SearchPipeModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    HomeModule,
    listiniVenditaModule,
    InternationalActivitiesModule,
    InternationalActivitiesUsermanualsModule,
    InternationalActivitiesdetailModule,
    EqualtecModule,
    //EqualtecdetailModule,
    ServiceItaModule,
    LoginModule,
    OpenIdLoginModule,
    RouterModule.forRoot(routes
      //   [
      //   { path: 'login', component: LoginComponent },
      //   { path: '', component: HomeComponent, pathMatch: 'full',canActivate: [AuthGuardService] },
      //   { path: 'counter', component: CounterComponent },
      //   { path: 'fetch-data', component: FetchDataComponent },
      //   // otherwise redirect to home
      //   { path: '**', redirectTo: '' }
      // ]
    ),
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      timeOut: 7000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    })
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [AuthGuardService],
  bootstrap: [AppComponent],
  entryComponents: [
    PhoneBookComponent,
    UserComponent,
    MeetingRoomStatusComponent,
    ChangelogComponent,
    EqualtecModalPresavisioneComponent
    //NavMenuComponent
    //ListiniVenditaComponent
  ]
})
export class AppModule {
  constructor() {
    registerLocaleData(localeIt, 'it');
    registerLocaleData(localeEn, 'en');
  }
}
